import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import { makeStyles } from "@material-ui/core";
import { Container, Typography } from "@material-ui/core";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const useStyles = makeStyles((theme) => ({
  breadcrumbs: {
    padding: "20px 0",
    backgroundColor: "#f8f8f8",
  },
  breadcrumbList: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  breadcrumbItem: {
    display: "flex",
    alignItems: "center",
  },
  breadcrumbLink: {
    color: "#07516c",
    textDecoration: "none",
    fontSize: "14px",
    fontWeight: "500",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  breadcrumbCurrent: {
    color: "#2D2D2D",
    fontSize: "14px",
    fontWeight: "500",
  },
  separator: {
    margin: "0 8px",
    color: "var(--color-neutral-400)",
    fontSize: "18px",
  },
}));

const Breadcrumbs = () => {
  const classes = useStyles();
  const location = useLocation();
  
  // Parse the current path
  const pathnames = location.pathname.split("/").filter((x) => x);
  
  // Don't show breadcrumbs on homepage
  if (pathnames.length === 0) {
    return null;
  }
  
  // Create breadcrumb items
  const breadcrumbItems = [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": "https://www.kinetx.co/"
    }
  ];
  
  // Build breadcrumb trail
  let currentPath = "";
  const breadcrumbLinks = pathnames.map((name, index) => {
    currentPath += `/${name}`;
    const isLast = index === pathnames.length - 1;
    
    // Format the name for display
    const displayName = name
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
    
    // Add to structured data
    breadcrumbItems.push({
      "@type": "ListItem",
      "position": index + 2,
      "name": displayName,
      "item": `https://www.kinetx.co${currentPath}`
    });
    
    return {
      name: displayName,
      path: currentPath,
      isLast,
    };
  });
  
  // Create BreadcrumbList structured data
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbItems
  };
  
  return (
    <div className={classes.breadcrumbs}>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbSchema)}
        </script>
      </Helmet>
      <Container maxWidth="lg">
        <nav aria-label="breadcrumb">
          <ol className={classes.breadcrumbList}>
            <li className={classes.breadcrumbItem}>
              <Link to="/" className={classes.breadcrumbLink}>
                Home
              </Link>
              <NavigateNextIcon className={classes.separator} />
            </li>
            {breadcrumbLinks.map((crumb, index) => (
              <li key={index} className={classes.breadcrumbItem}>
                {crumb.isLast ? (
                  <Typography className={classes.breadcrumbCurrent} aria-current="page">
                    {crumb.name}
                  </Typography>
                ) : (
                  <>
                    <Link to={crumb.path} className={classes.breadcrumbLink}>
                      {crumb.name}
                    </Link>
                    <NavigateNextIcon className={classes.separator} />
                  </>
                )}
              </li>
            ))}
          </ol>
        </nav>
      </Container>
    </div>
  );
};

export default Breadcrumbs;

